"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isSessionTypeChangedFromSessionToMain = exports.getBroadcastRoles = exports.boServiceErrorHandler = void 0;
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _editLockError = _interopRequireDefault(require("./edit-lock-error"));
var _constants = require("../constants");
// eslint-disable-next-line import/prefer-default-export

var getBroadcastRoles = exports.getBroadcastRoles = function getBroadcastRoles(options) {
  var recipientRoles = [];
  if (!options || !options.cohosts && !options.presenters) {
    return recipientRoles;
  }
  if (options.cohosts) {
    recipientRoles.push('COHOST');
  }
  if (options.presenters) {
    recipientRoles.push('PRESENTER');
  }
  return recipientRoles;
};

/**
 * Deals with all kinds of errors of breakout service
 * @param {object} error // one of the breakout service error
 * @param {string} position // position of the error occur
 * @returns {object}
 */
var boServiceErrorHandler = exports.boServiceErrorHandler = function boServiceErrorHandler(error, position) {
  var _error$body, _throwError;
  var errorCode = error === null || error === void 0 ? void 0 : (_error$body = error.body) === null || _error$body === void 0 ? void 0 : _error$body.errorCode;
  var _BREAKOUTS$ERROR_CODE = _constants.BREAKOUTS.ERROR_CODE,
    EDIT_LOCK_TOKEN_MISMATCH = _BREAKOUTS$ERROR_CODE.EDIT_LOCK_TOKEN_MISMATCH,
    EDIT_NOT_AUTHORIZED = _BREAKOUTS$ERROR_CODE.EDIT_NOT_AUTHORIZED;
  var throwError;
  switch (errorCode) {
    case EDIT_LOCK_TOKEN_MISMATCH:
      throwError = new _editLockError.default('Edit lock token mismatch', error);
      break;
    case EDIT_NOT_AUTHORIZED:
      throwError = new _editLockError.default('Not authorized to interact with edit lock', error);
      break;
    default:
      throwError = error;
  }
  _loggerProxy.default.logger.info("".concat(position, " --> ").concat((_throwError = throwError) === null || _throwError === void 0 ? void 0 : _throwError.message));
  return throwError;
};

/**
 *
 * @param {object} breakout
 * @param {string} newSessionType
 * @returns {boolean}
 */
var isSessionTypeChangedFromSessionToMain = exports.isSessionTypeChangedFromSessionToMain = function isSessionTypeChangedFromSessionToMain(breakout, newSessionType) {
  return breakout.previous('sessionType') === _constants.BREAKOUTS.SESSION_TYPES.BREAKOUT && newSessionType === _constants.BREAKOUTS.SESSION_TYPES.MAIN;
};
//# sourceMappingURL=utils.js.map
